import React, { Component } from "react";
import * as LottiePlayer from "@lottiefiles/lottie-player";
import { Navigate } from 'react-router-dom';
import { firebaseLoadingEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";
import {getSessionIdFromStorage} from '../../../utils/helpers/storageUtils';


export default class HummAnimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect:false

          }
    }

    componentDidMount() {
        firebaseLoadingEvent('humm_animation_loading')
        setTimeout(() => {
           this.setState({ redirect: true })
        }, 4500);
    }
    


    render() {
        if (this.state.redirect) {
            let sessionId = getSessionIdFromStorage();
            if (!sessionId) {
                sessionId = sessionStorage.getItem('sessionId') || localStorage.getItem('sessionId');
            }
            let userRole = localStorage.getItem('userRole');
			if (userRole === 'admin') {
				return <Navigate push to={sessionId ? "/admin-dashboard" : "/login"} />;
			}
			else {
				return <Navigate push to={sessionId ? "/home" : "/application-landing"} />;
			}
		}
        return (
            <div>
                <lottie-player
                     autoplay
                     loop
                     mode="normal"
                     src="humm_splash.json"
                     style={{width: '100%',height:'100vh',overflow:'hidden' }}
                ></lottie-player>
            </div>
        );
    }
}
